import React from "react";
import { isEqual, get } from "lodash";
import { connect } from "react-redux";
import { store } from "../../../store";

// components
import Input from "../forms/Input";
import * as actions from "../../../store/actions";
import FormFlowStepForm from "../forms/FormFlowStepForm";

/*
 * this must have five elements
 *
 * 1) Inputs that take data. One input type will be "custom", where you can pass it it's own react element
 * 2) A submit button that has a custom handler
 * 3) Substeps -- conditional logic that asks you more questions.
 * 4) A data requirement -- what makes it such that we need to send the next one
 * 5) An OnNext() method
 * 6) An OnPrev() method
 *
 *
 * Note that this element depends on a settable redux path to determine the value of the inputs. That react path is settable in redux.
 *
 * Note that this component should NOT HOST ANY STYLE OPINIONS. those can be added in the component sections
 *
 * */

class FormFlowStep extends React.Component {
  // constructor(config) {
  //
  //     this.config = {
  //         populateWithData: () => null,
  //         handleInput: () => null,
  //         areStepReqsMet: () => null,
  //         onNext: () => null,
  //         onPrev: () => null,
  //         ...config
  //     };
  //     this.reduxPath = config.REDUX_PATH;
  //     this.basedOnInputs = Array.isArray(config.inputs);
  //
  // }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  goToNextStep = () => {
    this.scrollToTop();
    if (this.props.onComplete) this.props.onComplete();
    window.gtag('event', 'formflow_next_step', {page: window.location.pathname})
    this.props.setCurrStep(this.props.currStep + 1);
  };

  goToPrevStep = () => {
    this.scrollToTop();
    if (!this.props.currStep >= 1) return;
    this.props.setCurrStep(this.props.currStep - 1);
  };

  areStepReqsMet = () => {
    if (this.props.areStepReqsMet) {
      return this.props.areStepReqsMet(this.props.responses);
    } if (this.props.inputs) {
      return this.props.inputs
        .filter((d) => d.validator)
        .every((d) => d.validator(this.props.responses[d.dataKey]));
    } 
      return true;
    
  };

  renderStepFormForInputs = () => {
    return <FormFlowStepForm {...this.props} />
  };

  getDisplayableComponent = () => {
    if (this.props.inputs) {
      if (!this.props.inputs.length) return <div />;

      if (Array.isArray(this.props.inputs[0])) {
        // handle substeps
        return 0;
      }
      return this.renderStepFormForInputs();
    }

    if (this.props.components) {
      // return this.config.component;
    }

    if (this.props.component) {
      return (
          <>
            {this.props.title &&
              <div className="form-section-header">
                {this.props.title}
              </div>
            }
            {this.props.component}
          </>
      )
    }
  };

  render() {
    return (
      <div className="ff-step">
        {this.getDisplayableComponent()}
        <div className="buttons mt-5">
          {!this.props.hideDefaultButtons && (
            <div
              className="buttons container-buttons-formflow mt-5 full-width"
            >
              {/* ${this.formHasError() || !this.formHasValues() ? 'disabled' : ''} */}
              <button
                className={`button is-link is-large ${
                  this.areStepReqsMet() ? "" : "disabled"
                }`}
                onClick={() => this.goToNextStep()}
              >
                Next
              </button>
              <button
                  className={`button   is-text ${
                      this.props.loading || this.props.currStep === 1
                          ? "disabled"
                          : ""
                  }`}
                  onClick={() => this.goToPrevStep()}
              >
                Back
              </button>
              {!!this.props.otherButtons && this.props.otherButtons}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currStep: state.formFlow.currStep,
  responses: state.formFlow.inputs,
  computed: state.formFlow.computed,
});

const mapDispatchToProps = (dispatch) => ({
  updateInputs: (data) => dispatch(actions.formFlow.updateFormFlowInputs(data)),
  updateComputed: (data) =>
    dispatch(actions.formFlow.updateFormFlowComputed(data)),
  setCurrStep: (data) => dispatch(actions.formFlow.setFormFlowCurrStep(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormFlowStep);
